import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      title: "SJ EuroNight Menu",
      subtitle: "Food and drinks onboard the SJ EuroNight",
      breakfast: "Breakfast",
      hotDishes: "Hot dishes and sandwiches",
      snacks: "Snacks",
      hotDrinks: "Hot drinks",
      nonAlcoholic: "Non-alcoholic drinks",
      beer: "Beer",
      wine: "Wine and sparkling wine",
      onboardArticles: "Onboard articles",
      thingsYouForgot: "Things you forgot",
      orderBreakfast: "You are welcome to order breakfast for the next morning until 11:30 p.m. the night before from our train team on board. As long as supply lasts.",
      allergens: "Allergens",
      additives: "Additives",
      noteCashless: "Please note that payments on board can only be made with debit and credit cards as well as Google and Apple Pay.",
      noteVAT: "Notice: from Stockholm to Hamburg we sell our products in SEK and charge Swedish VAT. From Hamburg to Stockholm we sell our products in EUR and charge German VAT.",
      serviceHours: "Food and beverages can be purchased in our service compartment in the sleeper car in the evenings until about 11:30 pm and in the mornings from 5:00 am.",
      priceNote: "All prices include taxes and fees.",
      selectionNote: "Please note that the selection of the range may vary.",
      organic: "organic",
      dry: "dry",
      vegan: "vegan",
      bistroStatus: "Bistro Status",
      serviceHoursLabel: "Service Hours",
      bistroLocation: "Bistro Location",
      car26Middle: "Car 26 (Middle of Train)",
      lookForStaff: "",
      cashlessOnly: "Cashless only: Card, Apple Pay, Google Pay",
      open: "OPEN",
      closed: "CLOSED",
      opensAt: "Opens at 05:00",
      closesAt: "Closes at 23:30",
      openUntil: "Open until 23:30",
      tomorrow: "05:00 (tomorrow)",
      pricingInformation: "Pricing Information",
      allPricesEur: "All prices are in EUR and include German VAT. Payment by card, Apple Pay, or Google Pay only.",
      northbound: "Northbound: Hamburg → Stockholm",
      germanVat: "Currency: EUR (German VAT applies)",
      quickNavigation: "Quick Navigation"
    }
  },
  de: {
    translation: {
      title: "SJ EuroNight Speisekarte",
      subtitle: "Speisen und Getränke an Bord des SJ EuroNight",
      breakfast: "Frühstück",
      hotDishes: "Warme Speisen und Sandwiches",
      snacks: "Snacks",
      hotDrinks: "Heißgetränke",
      nonAlcoholic: "Alkoholfreie Getränke",
      beer: "Bier",
      wine: "Wein und Sekt",
      onboardArticles: "Bordartikel",
      thingsYouForgot: "Dinge, die Sie vergessen haben",
      orderBreakfast: "Gerne kann ein Frühstück für den nächsten Morgen bis 23:30 Uhr am Vorabend bei unserem Zugteam an Bord bestellt werden. So lange der Vorrat reicht.",
      allergens: "Allergene",
      additives: "Zusatzstoffe",
      noteCashless: "Bitte beachten Sie, dass an Bord ausschließlich mit EC- und Kreditkarte sowie mit Google- und Apple Pay gezahlt werden kann.",
      noteVAT: "Hinweis: In Fahrtrichtung Stockholm nach Hamburg berechnen wir unser Angebot in SEK. Es gilt der schwedische Mehrwertsteuersatz. In Fahrtrichtung Hamburg nach Stockholm berechnen wir unser Angebot in EUR. Es gilt der deutsche Mehrwertsteuersatz.",
      serviceHours: "Das gesamte Getränke- und Speisenangebot kann in unserem Service-Abteil im Schlafwagen abends bis ca. 23:30 Uhr und morgens ab 5:00 Uhr erworben werden.",
      priceNote: "Alle Preise enthalten Steuern und Abgaben.",
      selectionNote: "Bitte beachten Sie, dass die Auswahl des Sortiments variieren kann.",
      organic: "Bio",
      dry: "trocken",
      vegan: "vegan",
      bistroStatus: "Bistro Status",
      serviceHoursLabel: "Servicezeiten",
      bistroLocation: "Bistro Standort",
      car26Middle: "Wagen 26 (Mitte des Zuges)",
      lookForStaff: "",
      cashlessOnly: "Nur bargeldlos: Karte, Apple Pay, Google Pay",
      open: "GEÖFFNET",
      closed: "GESCHLOSSEN",
      opensAt: "Öffnet um 05:00",
      closesAt: "Schließt um 23:30",
      openUntil: "Geöffnet bis 23:30",
      tomorrow: "05:00 (morgen)",
      pricingInformation: "Preisinformationen",
      allPricesEur: "Alle Preise sind in EUR und enthalten deutsche MwSt. Zahlung nur per Karte, Apple Pay oder Google Pay.",
      northbound: "Nordwärts: Hamburg → Stockholm",
      germanVat: "Währung: EUR (deutsche MwSt. gilt)",
      quickNavigation: "Schnellnavigation"
    }
  },
  sv: {
    translation: {
      title: "SJ EuroNight Meny",
      subtitle: "Mat och dryck ombord på SJ EuroNight",
      breakfast: "Frukost",
      hotDishes: "Varmrätter och smörgåsar",
      snacks: "Snacks",
      hotDrinks: "Varma drycker",
      nonAlcoholic: "Alkoholfria drycker",
      beer: "Öl",
      wine: "Vin",
      onboardArticles: "Artiklar ombord",
      thingsYouForgot: "Det du glömde",
      orderBreakfast: "Förbeställ gärna din frukost från personalen ombord fram till ca klockan 23.30 kvällen före. Så länge lagret räcker.",
      allergens: "Allergener",
      additives: "Tillsatser",
      noteCashless: "Observera att det är kontantfritt ombord. Betalning kan endast ske med kort eller Google-/Apple Pay.",
      noteVAT: "Från Stockholm till Hamburg betalar du i svenska kronor med svensk moms och från Hamburg till Stockholm i Euro med tysk moms.",
      serviceHours: "Mat och dryck finns att köpa i vår minibistro i sovvagnen fram till ca klockan 23.30 och från klockan 05.00 på morgonen.",
      priceNote: "Alla priser inkluderar skatter och avgifter.",
      selectionNote: "Utbudet kan variera.",
      organic: "ekologisk",
      dry: "torr",
      vegan: "vegansk",
      bistroStatus: "Bistro Status",
      serviceHoursLabel: "Servicetider",
      bistroLocation: "Bistro Plats",
      car26Middle: "Vagn 26 (Mitten av tåget)",
      lookForStaff: "",
      cashlessOnly: "Endast kontantlöst: Kort, Apple Pay, Google Pay",
      open: "ÖPPET",
      closed: "STÄNGT",
      opensAt: "Öppnar kl 05:00",
      closesAt: "Stänger kl 23:30",
      openUntil: "Öppet till 23:30",
      tomorrow: "05:00 (imorgon)",
      pricingInformation: "Prisinformation",
      allPricesEur: "Alla priser är i EUR och inkluderar tysk moms. Betalning endast med kort, Apple Pay eller Google Pay.",
      northbound: "Norrut: Hamburg → Stockholm",
      germanVat: "Valuta: EUR (tysk moms gäller)",
      quickNavigation: "Snabbnavigering"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;